import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import ForkRightIcon from '@mui/icons-material/ForkRight';
import SettingsIcon from '@mui/icons-material/Settings';
import RuleIcon from '@mui/icons-material/Rule';

import { selectUserPermissions, selectUserRoles } from '@store/auth';

import ApplicationTemplate from '@dashboardComponents/ApplicationTemplate/ApplicationTemplate';
import PaymentOrchestrationRules from './pages/rule-list/PaymentOrchestrationRules';
import OrchestrationRuleForm from './pages/rule-form/RuleForm';
import RuleSources from './pages/sources/RuleSources';
import DynamicRulesList from './pages/dynamic-rules/list/DynamicRulesList';
import DynamicRulesForm from './pages/dynamic-rules/form/DynamicRulesForm';

import { getFirstRoute } from '../../utils/utils';

import { ROLES } from '../../app/App.constants';
import {
  RULE_LIST_ROUTE,
  RULE_SOURCE_LIST_ROUTE,
  DYNAMIC_RULE_LIST_ROUTE,
} from './payment-orchestration.breadcrumbs';

const tabs = [
  {
    title: 'Rules',
    icon: <ForkRightIcon />,
    path: RULE_LIST_ROUTE,
    roles: [ROLES.ROLE_RULE_VIEW, ROLES.ROLE_RULE_EDIT],
  },
  {
    title: 'Sources',
    icon: <SettingsIcon />,
    path: RULE_SOURCE_LIST_ROUTE,
    roles: [ROLES.ROLE_SOURCE_VIEW, ROLES.ROLE_SOURCE_EDIT],
  },
  {
    title: 'Dynamic Rules',
    icon: <RuleIcon />,
    path: DYNAMIC_RULE_LIST_ROUTE,
    roles: [ROLES.ROLE_DYNAMIC_RULE_VIEW, ROLES.ROLE_DYNAMIC_RULE_EDIT],
  },
];

function Orchestration() {
  const permissions = useSelector(selectUserPermissions);
  const userRoles = useSelector(selectUserRoles);
  const firstRoute = getFirstRoute(userRoles, tabs);

  return (
    <ApplicationTemplate menu={tabs}>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to={firstRoute}
              replace
            />
          }
        />
        <Route
          path="/rules"
          exact
          element={<PaymentOrchestrationRules permissions={permissions} />}
        />
        <Route
          path="/rules/add"
          exact
          element={<OrchestrationRuleForm permissions={permissions} />}
        />
        <Route
          path="/rules/:id"
          exact
          element={<OrchestrationRuleForm permissions={permissions} />}
        />
        <Route
          path="/rules-sources/"
          exact
          element={<RuleSources permissions={permissions} />}
        />
        <Route
          path="/dynamic-rules/"
          exact
          element={<DynamicRulesList permissions={permissions} />}
        />
        <Route
          path="/dynamic-rules/add"
          exact
          element={<DynamicRulesForm permissions={permissions} />}
        />
        <Route
          path="/dynamic-rules/:id"
          exact
          element={<DynamicRulesForm permissions={permissions} />}
        />
      </Routes>
    </ApplicationTemplate>
  );
}

export default Orchestration;
